// Assets loading
import AakashLogo from './assets/aakash-logo.png'
import loginImage from './assets/login_student-image.png'
import neetbannermobile from './assets/neet_mweb_banner_asset.png'
import neetbannerdesktop from './assets/neet_web_banner_asset.png'
import invictusmwebbanner from './assets/webinvictusmobile.webp'
import jeebannerdesktop from './assets/jee_mock_modal_web.png'
import jeebannerMobile from './assets/jee_mock_modal_mobile.png'
import scholaricon from './assets/confetti-scholar_icon.svg'
import scholariconpeople from './assets/people_icon_circle.png'
import scholariconsparkle from './assets/scholarship-icon-form.svg'
import moneyiconjee from './assets/Money-jee.svg'
import neet_score_bg from './assets/neet_score_bg.webp'
import neet_rank_bg from './assets/neet_rank_bg.webp'
// Main Components templates
import NeetLandingTemplate from "components/NeetMockTest/NeetLandingTemplate"
import IacstLandingPageTemplate from "components/iACSTExam/IacstLandingPageTemplate"
import JEEMockLandingTemplate from 'components/JeeMockTest/JEEMockLandingTemplate'

// Faqs
import { InvictusFaqList } from "components/Invictus/InvictusFaqsData"
import { NeetmockFaq } from 'components/NeetMockTest/NeetfaqsData'
import { JEEmockFaq } from 'components/JeeMockTest/JeeFaqsData'

// Css loading
import signupStyles from 'components/Registration/Form/signupStyles.module.css'

// Config loading
import { banner_title as adstbannertittle, scholarships as adstscholarships, testcriteria as testcriteriaaakashdigital } from './components/iACSTExam/iacst_adstjson'
import { banner_title as neetrepeaterbannertitle, scholarships as neetRepeaterFaq, testcriteria as neetRepeatertestcriteria } from './components/iACSTExam/neetrepeaterJson'
import { banner_title as mediacalrepeaterbannertitle, scholarships as medicalengrepeaterFaq, testcriteria as medicalengrepeatertestcriteria } from './components/iACSTExam/medicalengrepeaterJson'
import { banner_title as neetrepeaterhindibannertitle, scholarships as neetrepeaterHindiFaq, testcriteria as neetrepeaterHindiJsontestcriteria } from './components/iACSTExam/neetrepeaterHindiJson'
import { banner_title as jeerepeaterbannertitle, scholarships as JeeRptFaq, testcriteria as JeeRpterscholarshipCriteria } from './components/iACSTExam/Jeerepeaterscholarshipjson'
import { banner_title as iacstMedicalEngbannertitle, scholarships as iacstMedicalEngineeringRepeaterCoursesHindiFaq, testcriteria as iacstMedicalEngineeringRepeaterCoursesHindiJsontestcriteria } from './components/iACSTExam/iacstMedicalEngineeringRepeaterCoursesHindiJson'
import { scholarships, testcriteria, banner_title } from './components/iACSTExam/iacstMainPageContentjson'
import InvictusLandingTemplate from 'components/IAT/InvictusLandingTemplate'
import config from 'config'

const iacstPagesMap = {
  "adst": {
    commonSettings: {
      supportNumber: "8800312674"
    },
    registerTemplate: {
      helmet: {
        title: "Aakash Digital Scholarship Test - Get Up to 60% Scholarship On NEET, JEE & Foundation Courses",
        metas: [
          {
            name: "description",
            content: "Aakash Digital Scholarship Test - Get Up to 60% Scholarship On NEET, JEE & Foundation Courses. Register Now to get the scholarship."
          },
          {
            property: "og:type",
            content: "website"
          },
          {
            property: "og:url",
            content: "https://aakashdigital.com/adst"
          },
          {
            property: "og:title",
            content: "Aakash Digital Scholarship Test - Get Up to 60% Scholarship On NEET, JEE & Foundation Courses"
          },
          {
            property: "og:description",
            content: "Aakash Digital Scholarship Test - Get Up to 60% Scholarship On NEET, JEE & Foundation Courses. Register Now to get the scholarship."
          },
          {
            property: "og:image",
            content: "https://dcx0p3on5z8dw.cloudfront.net/Aakash/s3fs-public/inline-images/invictus/white-aakash-logo.png"
          },
          {
            name: "twitter:card",
            content: "summary_large_image"
          },
          {
            name: "twitter:title",
            content: "Aakash Digital Scholarship Test - Get Up to 60% Scholarship On NEET, JEE & Foundation Courses"
          },
          {
            name: "twitter:description",
            content: "Aakash Digital Scholarship Test - Get Up to 60% Scholarship On NEET, JEE & Foundation Courses. Register Now to get the scholarship."
          },
          {
            name: "twitter:image",
            content: "https://dcx0p3on5z8dw.cloudfront.net/Aakash/s3fs-public/inline-images/invictus/white-aakash-logo.png"
          }
        ],
        link: {
          rel: "canonical",
          href: "https://aakashdigital.com/adst"
        }
      },
      heroBanner: {
        banner_title: [
          {
            webBanner: adstbannertittle[0].imagebanner,
            mobBanner: adstbannertittle[0].imagebanner,
            "styles": "text-center text-md-start mt-2 d-block align-content-end"
          }
        ],
        tncUrl: 'https://iacst.aakash.ac.in/iacst-scholarship/terms-conditions',
        privacypolicyUrl: 'https://www.aakash.ac.in/privacypolicy',
      },
      faqComponent: {
        questions: adstscholarships
      },
      test_criteria: testcriteriaaakashdigital
    }
  },
  "neet-repeater-scholarship": {
    registerTemplate: {
      helmet: {
        title: "Repeater Courses for NEET 2026: Aakash iACST - Instant Scholarship",
        metas: [
          {
            name: "description",
            content: "Aakash iACST Repeater Courses is a national level online scholarship test for Class 12th & 12th passout students for NEET 2026. Get scholarships instantly and get admission into Aakash."
          },
          {
            property: "og:type",
            content: "website"
          },
          {
            property: "og:url",
            content: "https://iacst.aakash.ac.in/neet-repeater-scholarship"
          },
          {
            property: "og:title",
            content: "Repeater Courses for NEET 2026: Aakash iACST - Instant Scholarship"
          },
          {
            property: "og:description",
            content: "Aakash iACST Repeater Courses is a national level online scholarship test for Class 12th & 12th passout students for NEET 2026. Get scholarships instantly and get admission into Aakash."
          },
          {
            property: "og:image",
            content: "https://dcx0p3on5z8dw.cloudfront.net/Aakash/s3fs-public/inline-images/invictus/white-aakash-logo.png"
          },
          {
            name: "twitter:card",
            content: "summary_large_image"
          },
          {
            name: "twitter:title",
            content: "Repeater Courses for NEET 2026: Aakash iACST - Instant Scholarship"
          },
          {
            name: "twitter:description",
            content: "Aakash iACST Repeater Courses is a national level online scholarship test for Class 12th & 12th passout students for NEET 2026. Get scholarships instantly and get admission into Aakash."
          },
          {
            name: "twitter:image",
            content: "https://dcx0p3on5z8dw.cloudfront.net/Aakash/s3fs-public/inline-images/invictus/white-aakash-logo.png"
          }
        ],
        link: {
          rel: "canonical",
          href: "https://iacst.aakash.ac.in/neet-repeater-scholarship"
        }
      },
      heroBanner: {
        banner_title: [
          {
            "webBanner": neetrepeaterbannertitle[0].imagebanner,
            "mobBanner": neetrepeaterbannertitle[0].imagebanner,
            "styles": "text-center text-md-start mt-2 d-block align-content-end"
          }
        ],
        tncUrl: 'https://iacst.aakash.ac.in/iacst-scholarship/terms-conditions',
        privacypolicyUrl: 'https://www.aakash.ac.in/privacypolicy',
      },

      faqComponent: {
        questions: neetRepeaterFaq,
      },
      test_criteria: neetRepeatertestcriteria
    }
  },
  "iacst-medical-engineering-repeater-courses": {
    registerTemplate: {
      helmet: {
        title: "Repeater Courses for NEET & JEE 2026: Aakash iACST - Instant Scholarship",
        metas: [
          {
            name: "description",
            content: "Aakash iACST Repeater Courses is a national level online scholarship test for Class 12th & 12th passout students for NEET / JEE 2026. Get scholarships instantly and get admission into Aakash."
          },
          {
            property: "og:type",
            content: "website"
          },
          {
            property: "og:url",
            content: "https://iacst.aakash.ac.in/iacst-medical-engineering-repeater-courses"
          },
          {
            property: "og:title",
            content: "Repeater Courses for NEET & JEE 2026: Aakash iACST - Instant Scholarship"
          },
          {
            property: "og:description",
            content: "Aakash iACST Repeater Courses is a national level online scholarship test for Class 12th & 12th passout students for NEET / JEE 2026. Get scholarships instantly and get admission into Aakash."
          },
          {
            property: "og:image",
            content: "https://dcx0p3on5z8dw.cloudfront.net/Aakash/s3fs-public/inline-images/invictus/white-aakash-logo.png"
          },
          {
            name: "twitter:card",
            content: "summary_large_image"
          },
          {
            name: "twitter:title",
            content: "Repeater Courses for NEET & JEE 2026: Aakash iACST - Instant Scholarship"
          },
          {
            name: "twitter:description",
            content: "Aakash iACST Repeater Courses is a national level online scholarship test for Class 12th & 12th passout students for NEET / JEE 2026. Get scholarships instantly and get admission into Aakash."
          },
          {
            name: "twitter:image",
            content: "https://dcx0p3on5z8dw.cloudfront.net/Aakash/s3fs-public/inline-images/invictus/white-aakash-logo.png"
          }
        ],
        link: {
          rel: "canonical",
          href: "https://iacst.aakash.ac.in/iacst-medical-engineering-repeater-courses"
        }
      },
      heroBanner: {
        banner_title: [
          {
            "webBanner": mediacalrepeaterbannertitle[0].imagebanner,
            "mobBanner": mediacalrepeaterbannertitle[0].imagebanner,
          }
        ],
        tncUrl: 'https://iacst.aakash.ac.in/iacst-scholarship/terms-conditions',
        privacypolicyUrl: 'https://www.aakash.ac.in/privacypolicy',
      },
      faqComponent: {
        questions: medicalengrepeaterFaq
      },
      test_criteria: medicalengrepeatertestcriteria
    }
  },
  "neet-repeater-scholarship-hindi": {
    registerTemplate: {
      helmet: {
        title: "NEET 2026 के लिए रिपीटर कोर्स: आकाश iACST द्वारा  तत्काल छात्रवृत्ति",
        metas: [
          {
            name: "description",
            content: "आकाश iACST रिपीटर कोर्स कक्षा 12वीं और 12वीं पास करने वाले छात्रों के लिए NEET 2026 के लिए एक राष्ट्रीय स्तर की ऑनलाइन छात्रवृत्ति परीक्षा है। तुरंत छात्रवृत्ति प्राप्त करें और आकाश में प्रवेश पाएं।"
          },
          {
            property: "og:type",
            content: "website"
          },
          {
            property: "og:url",
            content: "https://iacst.aakash.ac.in/neet-repeater-scholarship-hindi"
          },
          {
            property: "og:title",
            content: "NEET 2026 के लिए रिपीटर कोर्स: आकाश iACST द्वारा  तत्काल छात्रवृत्ति"
          },
          {
            property: "og:description",
            content: "आकाश iACST रिपीटर कोर्स कक्षा 12वीं और 12वीं पास करने वाले छात्रों के लिए NEET 2026 के लिए एक राष्ट्रीय स्तर की ऑनलाइन छात्रवृत्ति परीक्षा है। तुरंत छात्रवृत्ति प्राप्त करें और आकाश में प्रवेश पाएं।"
          },
          {
            property: "og:image",
            content: "https://dcx0p3on5z8dw.cloudfront.net/Aakash/s3fs-public/inline-images/invictus/white-aakash-logo.png"
          },
          {
            name: "twitter:card",
            content: "summary_large_image"
          },
          {
            name: "twitter:title",
            content: "NEET 2026 के लिए रिपीटर कोर्स: आकाश iACST द्वारा  तत्काल छात्रवृत्ति"
          },
          {
            name: "twitter:description",
            content: "आकाश iACST रिपीटर कोर्स कक्षा 12वीं और 12वीं पास करने वाले छात्रों के लिए NEET 2026 के लिए एक राष्ट्रीय स्तर की ऑनलाइन छात्रवृत्ति परीक्षा है। तुरंत छात्रवृत्ति प्राप्त करें और आकाश में प्रवेश पाएं।"
          },
          {
            name: "twitter:image",
            content: "https://dcx0p3on5z8dw.cloudfront.net/Aakash/s3fs-public/inline-images/invictus/white-aakash-logo.png"
          }
        ],
        link: {
          rel: "canonical",
          href: "https://iacst.aakash.ac.in/neet-repeater-scholarship-hindi"
        }
      },
      heroBanner: {
        banner_title: [
          {
            "webBanner": neetrepeaterhindibannertitle[0].imagebanner,
            "mobBanner": neetrepeaterhindibannertitle[0].imagebanner,
          }
        ],
        tncUrl: 'https://iacst.aakash.ac.in/iacst-scholarship/terms-conditions',
        privacypolicyUrl: 'https://www.aakash.ac.in/privacypolicy',
      },
      faqComponent: {
        questions: neetrepeaterHindiFaq
      },
      test_criteria: neetrepeaterHindiJsontestcriteria
    }

  },
  "jee-repeater-scholarship": {
    registerTemplate: {
      helmet: {
        title: "Repeater Courses for JEE 2026: Aakash iACST - Instant Scholarship",
        metas: [
          {
            name: "description",
            content: "Aakash iACST Repeater Courses is a national level online scholarship test for Class 12th & 12th passout students for JEE 2026. Get scholarships instantly and get admission into Aakash."
          },
          {
            property: "og:type",
            content: "website"
          },
          {
            property: "og:url",
            content: "https://iacst.aakash.ac.in/jee-repeater-scholarship"
          },
          {
            property: "og:title",
            content: "Repeater Courses for JEE 2026: Aakash iACST - Instant Scholarship"
          },
          {
            property: "og:description",
            content: "Aakash iACST Repeater Courses is a national level online scholarship test for Class 12th & 12th passout students for JEE 2026. Get scholarships instantly and get admission into Aakash."
          },
          {
            property: "og:image",
            content: "https://dcx0p3on5z8dw.cloudfront.net/Aakash/s3fs-public/inline-images/invictus/white-aakash-logo.png"
          },
          {
            name: "twitter:card",
            content: "summary_large_image"
          },
          {
            name: "twitter:title",
            content: "Repeater Courses for JEE 2026: Aakash iACST - Instant Scholarship"
          },
          {
            name: "twitter:description",
            content: "Aakash iACST Repeater Courses is a national level online scholarship test for Class 12th & 12th passout students for JEE 2026. Get scholarships instantly and get admission into Aakash."
          },
          {
            name: "twitter:image",
            content: "https://dcx0p3on5z8dw.cloudfront.net/Aakash/s3fs-public/inline-images/invictus/white-aakash-logo.png"
          }
        ],
        link: {
          rel: "canonical",
          href: "https://iacst.aakash.ac.in/jee-repeater-scholarship"
        }
      },
      heroBanner: {
        banner_title: [
          {
            "webBanner": jeerepeaterbannertitle[0].imagebanner,
            "mobBanner": jeerepeaterbannertitle[0].imagebanner,
          }
        ],
        tncUrl: 'https://iacst.aakash.ac.in/iacst-scholarship/terms-conditions',
        privacypolicyUrl: 'https://www.aakash.ac.in/privacypolicy',
      },
      faqComponent: {
        questions: JeeRptFaq
      },
      test_criteria: JeeRpterscholarshipCriteria
    }
  },
  "iacst-medical-engineering-repeater-courses-hindi": {
    registerTemplate: {
      helmet: {
        title: "NEET और JEE 2026 के लिए रिपीटर कोर्स: आकाश iACST द्वारा  तत्काल छात्रवृत्ति",
        metas: [
          {
            name: "description",
            content: "आकाश iACST रिपीटर कोर्स कक्षा 12वीं और 12वीं पास करने वाले छात्रों के लिए NEET / JEE 2026 के लिए एक राष्ट्रीय स्तर की ऑनलाइन छात्रवृत्ति परीक्षा है। तुरंत छात्रवृत्ति प्राप्त करें और आकाश में प्रवेश पाएं।"
          },
          {
            property: "og:type",
            content: "website"
          },
          {
            property: "og:url",
            content: "https://iacst.aakash.ac.in/iacst-medical-engineering-repeater-courses-hindi"
          },
          {
            property: "og:title",
            content: "NEET और JEE 2026 के लिए रिपीटर कोर्स: आकाश iACST द्वारा  तत्काल छात्रवृत्ति"
          },
          {
            property: "og:description",
            content: "आकाश iACST रिपीटर कोर्स कक्षा 12वीं और 12वीं पास करने वाले छात्रों के लिए NEET / JEE 2026 के लिए एक राष्ट्रीय स्तर की ऑनलाइन छात्रवृत्ति परीक्षा है। तुरंत छात्रवृत्ति प्राप्त करें और आकाश में प्रवेश पाएं।"
          },
          {
            property: "og:image",
            content: "https://dcx0p3on5z8dw.cloudfront.net/Aakash/s3fs-public/inline-images/invictus/white-aakash-logo.png"
          },
          {
            name: "twitter:card",
            content: "summary_large_image"
          },
          {
            name: "twitter:title",
            content: "NEET और JEE 2026 के लिए रिपीटर कोर्स: आकाश iACST द्वारा  तत्काल छात्रवृत्ति"
          },
          {
            name: "twitter:description",
            content: "आकाश iACST रिपीटर कोर्स कक्षा 12वीं और 12वीं पास करने वाले छात्रों के लिए NEET / JEE 2026 के लिए एक राष्ट्रीय स्तर की ऑनलाइन छात्रवृत्ति परीक्षा है। तुरंत छात्रवृत्ति प्राप्त करें और आकाश में प्रवेश पाएं।"
          },
          {
            name: "twitter:image",
            content: "https://dcx0p3on5z8dw.cloudfront.net/Aakash/s3fs-public/inline-images/invictus/white-aakash-logo.png"
          }
        ],
        link: {
          rel: "canonical",
          href: "https://iacst.aakash.ac.in/iacst-medical-engineering-repeater-courses-hindi"
        }
      }
      ,
      heroBanner: {
        banner_title: [
          {
            "webBanner": iacstMedicalEngbannertitle[0].imagebanner,
            "mobBanner": iacstMedicalEngbannertitle[0].imagebanner,
          }
        ],
        tncUrl: 'https://iacst.aakash.ac.in/iacst-scholarship/terms-conditions',
        privacypolicyUrl: 'https://www.aakash.ac.in/privacypolicy',
      },
      faqComponent: {
        questions: iacstMedicalEngineeringRepeaterCoursesHindiFaq
      },
      test_criteria: iacstMedicalEngineeringRepeaterCoursesHindiJsontestcriteria
    }
  }
}

export const exam_config_all = {
  "MOCK-NEET": {
    commonSettings: {
      supportNumber: "8800013123",
      supportEmail: "care@aesl.in",
      registerPath: "/mock-neet-exam"
    },
    loginTemplate: {
      loginImage: loginImage,
      loginImageText: "Unlock your potential and take the first step toward your dreams."
    },
    registerTemplate: {

      header: {
        bgColor: 'white',
        logo: AakashLogo,
        logoClass: 'w-4 w-lg-5',
      },
      footer: {},
      heroBanner: {
        banner_title: [
          {
            webBanner: neetbannerdesktop,
            mobBanner: neetbannermobile,
            styles: `text-center text-md-start mt-2 d-block align-content-end`
          }
        ],
        tncUrl: 'https://neet-mocktest.aakash.ac.in/neet-mock-test/tc',
        privacypolicyUrl: 'https://www.aakash.ac.in/privacypolicy',
        styles: {
          bgClass: signupStyles.neetBgsection,
          desktopBanner: signupStyles.neet_web_model,
          mobileBanner: '',
          banner_wrapper: `container py-3 pb-0 px-0 d-flex flex-column flex-md-row justify-content-between ${signupStyles.formWrapper}`
        },
        Formfooter: {
          img: scholaricon,
          text: "4 Lac NEET Qualifiers in Last 5 Years"
        },
        Formheader: {
          img: scholariconpeople,
          text: "Total Registrations So Far:"
        }
      },
      mainBodyComponent: <NeetLandingTemplate />,
      faqComponent: {
        questions: NeetmockFaq,
        bgColor: ''
      },

    },
  },
  iACST: {
    commonSettings: {
      supportNumber: "7303529494",
      supportEmail: "acstsupport@aesl.in",
      registerPath: "/iacstexam"
    },
    loginTemplate: {
      loginImage: loginImage,
      loginImageText: "A scholarship exam for class 5th to 12th studying and passed students",
    },
    registerTemplate: {

      header: {
        bgColor: 'white',
        logo: AakashLogo,
        logoClass: 'w-4 w-lg-5',
      },
      footer: {},
      heroBanner: {
        banner_title: [
          {
            webBanner: banner_title[0].imagebanner,
            mobBanner: banner_title[0].imagebanner,
            styles: `text-center text-md-start mt-2 d-block align-content-end`
          }
        ],
        tncUrl: 'https://iacst.aakash.ac.in/iacst-scholarship/terms-conditions',
        privacypolicyUrl: 'https://www.aakash.ac.in/privacypolicy',
        styles: {
          bgClass: signupStyles.bgColor,
          desktopBanner: '',
          mobileBanner: '',
          banner_wrapper: `container py-3 pb-0 px-0 d-flex flex-column flex-md-row justify-content-between ${signupStyles.formWrapper}`
        },
        Formfooter: {
          img: scholariconsparkle,
          text: "More than <strong>155,300 Scholarships</strong> awarded last year"
        }
      },
      mainBodyComponent: <IacstLandingPageTemplate />,
      test_criteria: testcriteria,
      faqComponent: {
        questions: scholarships
      }
    },

    // Above keys will be default values if no values found for particular page
    multiPageConfig: iacstPagesMap
  },
  IAT: {
    commonSettings: {
      supportNumber: "1800-102-2727",
      supportEmail: "support.invictus@aesl.in",
      registerPath: "/invictus"
    },
    loginTemplate: {
      loginImage: loginImage,
      loginImageText: "Unlock your potential and take the first step toward your dreams.",
    },
    registerTemplate: {
      // header: {
      //     bgColor: '#0C2D62',
      //     logo: "https://dcx0p3on5z8dw.cloudfront.net/Aakash/s3fs-public/inline-images/invictus/white-aakash-logo.png",
      //     logoClass: 'w-6 w-lg-8',
      //     callcolor: "#fff",
      //     numbercolor: "#fff",
      // },
      header: {
        bgColor: 'white',
        logo: AakashLogo,
        logoClass: 'w-4 w-lg-5',
      },
      footer: {},
      heroBanner: {
        banner_title: [
          {
            webBanner: "",
            mobBanner: invictusmwebbanner,
            styles: `text-center text-md-start mt-0 d-block align-content-end`
          }
        ],
        tncUrl: 'https://www.aakash.ac.in/invictus-ace-tnc',
        privacypolicyUrl: 'https://www.aakash.ac.in/invictus-ace-privacy-policy',
        styles: {
          bgClass: signupStyles.invictusBgSection,
          desktopBanner: signupStyles.neet_web_model,
          mobileBanner: '',
          banner_wrapper: `container pb-0 px-0 d-flex flex-column flex-md-row justify-content-between dark-blue-100 ${signupStyles.formWrapper} ${signupStyles.invictusdark}`
        },
        Formfooter: {
          img: scholaricon,
          text: "1,10,000 Students placed in IITs and other colleges"
        }
      },
      mainBodyComponent: <InvictusLandingTemplate />,
      faqComponent: {
        questions: InvictusFaqList,
        bgcolor: '',
      }
    },
  },
  "MOCK-JEE": {
    commonSettings: {
      supportNumber: "8800012998",
      supportEmail: "care@aesl.in",
      registerPath: "/mock-jee-exam"
    },
    loginTemplate: {
      loginImage: loginImage,
      loginImageText: "Unlock your potential and take the first step toward your dreams."
    },
    registerTemplate: {
      header: {
        bgColor: 'white',
        logo: AakashLogo,
        logoClass: 'w-4 w-lg-5',
      },
      footer: {},
      heroBanner: {
        banner_title: [
          {
            webBanner: jeebannerdesktop,
            mobBanner: jeebannerMobile,
            styles: `text-center text-md-start mt-2 d-block align-content-end`
          }
        ],
        tncUrl: 'https://www.aakash.ac.in/jee-advanced-mock-test-series-terms-and-conditions',
        privacypolicyUrl: 'https://www.aakash.ac.in/jee-advanced-mock-test-series-privacy-policy',
        styles: {
          bgClass: signupStyles.JeemockBgSection,
          desktopBanner: signupStyles.jee_web_model,
          mobileBanner: signupStyles.jee_mobile_model,
          banner_wrapper: `container py-3 pb-0 px-0 d-flex flex-column flex-md-row justify-content-between ${signupStyles.formWrapper}`
        },
        Formfooter: {
          img: moneyiconjee,
          text: 'Register and book your seat today!'
        }
      },
      mainBodyComponent: <JEEMockLandingTemplate />,
      faqComponent: {
        questions: JEEmockFaq,
        bgcolor: '#F6F9FC'
      },
    },
  }
}


export const infoCardsData = {
  cards: [
    {
      id: "neet_score_calculator",
      tag: "New",
      title: "NEET Score Calculator",
      description: "Upload OMR for instant score",
      features: [
        "Upload your OMR sheet seamlessly",
        "Get results with up to 99% accuracy",
        "Designed as per official NTA exam pattern"
      ],
      cta: {
        text: "Calculate My Score",
        link: `${config.CLASS_BASE_URL}/neet-score-calculator`
      },
      theme: {
        icon: neet_score_bg,
        gradient: "#9C96F180",
        iconStyle: "#C4C0F799"
      }
    },
    {
      id: "neet_rank_predictor",
      tag: "New",
      title: "NEET Rank Predictor",
      description: "Predict your NEET rank and colleges",
      features: [
        "Get your results in just 2 minutes",
        "Explore 1,200+ colleges across India",
        "Access latest 2024 cut-offs easily"
      ],
      cta: {
        text: "Predict My Rank",
        link: `${config.CLASS_BASE_URL}/neet-rank-college-predictor`
      },
      theme: {
        icon: neet_rank_bg,
        gradient: "#9C96F180",
        iconStyle: "#C4C0F799"
      }
    }
  ]
};